import React from 'react';

import { observer } from 'mobx-react'

import Checkbox from '@material-ui/core/Checkbox';
import { fade as alpha, makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: alpha(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(3),
            width: 'auto',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
})
);


const CheckBoxFilter = observer(({ store, filterName, filterValue, label }) => {

    //const searchTerm = store.selectObjectsState.filter["search.all"] ?  store.selectObjectsState.filter["search.all"]: "";

    const checked  = store.selectObjectsState.filter[filterName] ? store.selectObjectsState.filter[filterName] : false;


    const handleChange = (event) => {
        const isChecked = event.target.checked
        if (isChecked) {
            store.setFilterPart({ [filterName]: filterValue });
        } else {
            store.setFilterPart({ [filterName]: null });

        }
    };


    return <div>{label}
        <Checkbox checked={checked} onChange={handleChange} />
    </div>
});

export default CheckBoxFilter;